import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from './components/Layout';
import NotFound from "./pages/NotFound";
import Base64 from "./pages/Base64Convert"
import PasswordGenerator from "./pages/PasswordGenerator";
import JsonFormatter from "./pages/JSONFormatter";
import WordCounter from "./pages/WordCounter"
import SampleImageGenerator from "./pages/SampleImageGenerator"
// import BreathingGuide from "./pages/Breathe";

const App = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Base64 />} />
        <Route path="/base64encode" element={<Base64 view="encode" />} />
        <Route path="/base64decode" element={<Base64 />} />
        <Route path="/password-generator" element={<PasswordGenerator />} />
        <Route path="/json-formatter" element={<JsonFormatter />} />
        <Route path="/word-counter" element={<WordCounter />} />
        <Route path="/image-generator" element={<SampleImageGenerator />} /> {/* TODO: enhance ui */}
        {/* <Route path="/breathe" element={<BreathingGuide />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
};

export default App;
